import { useRouter } from 'next/router';
import Topics from '@cont/Syllabus/HomePage/Topics';
import { NOTES, SYLLABUS_CLICKED_KEYS } from '@constants/segment';
import styled from '@emotion/styled';
import Dynamic from '@base/Dynamic/Dynamic';
import useFetch from '@hooks/useFetch';
import { segment } from '@actions/analytics';
import useGoalEventProps from '@hooks/useGoalEventProps';
import { evtNameCategoryMap } from '@constants/index';
import {
  getTopicListEndpoint,
  NOTES_TOPIC_SELECTED
} from '@cont/EpubNotes/utils';
import cookies from '@utils/cookies';
import { localStorageAvailable } from '@utils/localStorage';
import Header from './Header';
import FeatureIntroduction from './FeatureIntroduction';

const Wrapper = styled.div`
  grid-column: 1/-1;
  width: 100%;
`;

const NotificationToOlderBrowsers = Dynamic(
  () => import('@cont/EpubNotes/NotificationToOlderBrowsers')
);

const NotesHomePage = ({ goalTopology, fromStore }) => {
  const {
    query: { goalSlug, goalUID }
  } = useRouter();
  const { data: topicsInfo = [] } = useFetch(getTopicListEndpoint(goalUID));
  const goalSegmentData = useGoalEventProps({ goalUID: goalUID as string });
  const topicCardClick = (topic) => {
    let notesSegmentData = {};
    const { name } = topic;
    if (localStorageAvailable()) {
      notesSegmentData = JSON.parse(localStorage.getItem('notesSegmentData'));
    }
    segment.track(
      NOTES_TOPIC_SELECTED,
      {
        ...goalSegmentData,
        ...notesSegmentData,
        last_primary_source: NOTES,
        last_primary_source_section: 'Notes',
        notes_topic: name
      },
      evtNameCategoryMap.WITHOUT_CATEGORY,
      true,
      SYLLABUS_CLICKED_KEYS
    );
  };
  const isNotesVisited = cookies.readCookie('notesPageVisited', false);

  return (
    <Wrapper>
      <NotificationToOlderBrowsers />
      <Header goalTopology={goalTopology} fromStore={fromStore} />
      <Topics
        goalUID={goalUID as string}
        goalSlug={goalSlug}
        data={topicsInfo}
        source={NOTES}
        topicCardClick={topicCardClick}
      />
      {!isNotesVisited && <FeatureIntroduction goalUID={goalUID as string} />}
    </Wrapper>
  );
};

export default NotesHomePage;
